import React, { useState, useEffect } from "react";
import { Avatar, Card, CardContent, Grid, Typography } from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import Filter5Icon from "@mui/icons-material/Filter5";

const CloudSpent = (props) => {
  const [labscard, setLabscard] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/billingview/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setLabscard(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Card
      style={{ textAlign: "center" }}
      sx={{ height: "100%", border: 1, borderColor: "text.primary" }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          justify="center"
          sx={{ justifyContent: "space-between" }}
        >
          <Grid item>
            <Typography
              align="center"
              variant="h6"
              gutterBottom
              component="div"
            >
              CLOUD
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              SPENT:
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {`${labscard.cloud}`}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: lightBlue[600],
                height: 56,
                width: 56,
              }}
            >
              <Filter5Icon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CloudSpent;
